import * as Yup from 'yup';

export const CodeSchema = Yup.object().shape({
  code: Yup.string()
    .required('کد تایید اجباری می باشد')
    .matches(/^\d+$/, 'کد باید فقط شامل عدد باشد')
    .length(5, 'کد وارد شده درست نمی باشد'),
});
